// Мобильные утилиты: haptic feedback (Vibration API), определение устройства, качество графики.

export function haptic(pattern: number | number[] = 12): void {
  if (localStorage.getItem('sk_haptics') === 'off') return;
  try {
    navigator.vibrate?.(pattern);
  } catch {
    // вибрация недоступна
  }
}

/** Desktop: точный указатель и широкий экран → PixiJS; мобильные → Canvas 2D (легче). */
export function isDesktop(): boolean {
  return window.matchMedia('(pointer: fine)').matches && window.innerWidth >= 1024;
}

/** Adaptive quality: слабые устройства (≤ 4 ядер или мало памяти) — без анимации волн и частиц. */
export function lowEndDevice(): boolean {
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  return (
    (navigator.hardwareConcurrency ?? 8) <= 4 ||
    (mem !== undefined && mem <= 2) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/**
 * «Жизнь» в замке и на полях (люди, телеги, стройка): выключается только при системной настройке
 * «уменьшить движение» или совсем малой памяти; на слабых устройствах — реже кадры, а не пропадает.
 */
export function lifeAnimationsAllowed(): boolean {
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !(mem !== undefined && mem < 1);
}

/** Интервал кадров «жизни»: ~25 кадров/с, на слабых устройствах ~12. */
export function lifeFrameMs(): number {
  return lowEndDevice() ? 80 : 40;
}

export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}
